import { useCallback, useMemo } from 'react';

import { VOID_FUNCTION } from 'constants/index';

import { useValidationParts } from '../../hooks/useValidationParts';
import { getChangeEvent } from '../../Insurance.helpers';

import { DEFAULT_VALUES } from './FullNameInputs.constants';
import { findGenderId, generateFullName, generateFullNameParts } from './FullNameInputs.helpers';
import { schema } from './FullNameInputs.validation';

export const useFullNameInputsPresenter = ({
  error = '',
  name,
  onChange: onChangeProp = VOID_FUNCTION,
  onChangeGender = VOID_FUNCTION,
  value = '',
}) => {
  const parts = useMemo(() => {
    return generateFullNameParts({ value });
  }, [value]);

  const { errors } = useValidationParts({ error, parts, schema });

  const onChange = useCallback(
    (event) => {
      const { key, value } = getChangeEvent(event);

      const result = { ...parts, [key]: value };

      if (typeof value !== 'string') {
        const { data, value: daDataValue } = value;
        const { gender: daDataGender } = data ?? {};

        result[key] = daDataValue;

        const gender = findGenderId({ gender: daDataGender });

        if (typeof gender !== 'undefined') {
          onChangeGender(gender);
        }
      }

      const fullName = generateFullName({ parts: result });

      onChangeProp(name ? { [name]: fullName } : fullName);
    },
    [parts, onChangeGender, onChangeProp, name]
  );

  return { errors, onChange, values: { ...DEFAULT_VALUES, ...parts } };
};
